import SpeakButton from "@/components/SpeakButton";
import { motion } from "framer-motion";
import { useT } from "@/i18n";
import { PRODUCTS, BIZ_TEXT } from "@/components/business/products";

export default function ProductPicker({ selected, onSelect, other, setOther }) {
  const { lang } = useT();
  const tx = BIZ_TEXT[lang];
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.step1}</h3><SpeakButton compact mascot="lumi" text={tx.step1} testId="ask-business-step1" /></div>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3">
        {PRODUCTS.map((p) => {
          const Icon = p.icon;
          const active = selected === p.id;
          return (
            <motion.button
              key={p.id}
              type="button"
              whileTap={{ scale: 0.93 }}
              whileHover={{ y: -3 }}
              onClick={() => onSelect(p.id)}
              className={`${p.color} rounded-2xl border-4 p-3 flex flex-col items-center gap-2 font-bold text-blue-950 shadow-md ${active ? "border-blue-600 ring-4 ring-blue-300" : "border-white"}`}
              data-testid={`biz-product-${p.id}`}
            >
              <Icon className="w-9 h-9" strokeWidth={2.2} />
              <span className="text-sm text-center leading-tight">{p[lang]}</span>
            </motion.button>
          );
        })}
      </div>
      {selected === "other" && (
        <input
          value={other}
          onChange={(e) => setOther(e.target.value)}
          maxLength={80}
          placeholder={tx.otherPh}
          className="mt-4 w-full bg-white border-4 border-white rounded-full px-5 py-3 font-semibold shadow-md focus:outline-none focus:ring-4 focus:ring-sky-300"
          data-testid="biz-other-input"
        />
      )}
    </div>
  );
}
